import React, {useState, useEffect} from 'react'
import classes from "../Homepage.module.css";
import {MDBAlert, MDBBtn} from "mdbreact";
import {Trans} from "react-i18next";
import {countries as countriesCode} from '../../../Utils/countries'
import Select from 'react-select'
import {categories, getAllCategories, getSubCategories} from "../../../Utils/category";
import {getAllTypes} from "../../../Utils/type";
import firebase from "../../../Config/firebase";
import {validateURL} from "../../../Utils/formValidate";

const db = firebase.firestore()

const countryOptArr = []
const NewPendingRequest = (props) => {
    const [newPendingRequest, setNewPendingRequest] = useState({
        country: '344',
        type: '',
        category: "",
        subCategory: "",
        description: "",
        url: '',
        title: "",
        rejected:false
    })
    const [submitting, setSubmitting] = useState(false)
    const [submitted, setSubmitted] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [requireReload, setRequireReload] = useState(false)
    const [requireFullReload, setRequireFullReload] = useState(false)
    const [isExist, setIsExist] = useState(false)

    useEffect(() => {
        countryOptions()
    }, [])

    const countryOptions = () => {
        countriesCode.map((country) => {
            countryOptArr.push({value: country.num_code, label: country.en_short_name});
        })
    }

    const checkExistFn = async (url) => {
        return new Promise(async (resolve, reject) => {
            const checkPending = await new Promise((resolve, reject) => {
                db.collection('Pending')
                    .where('url', "==", url)
                    .get()
                    .then(docs => {
                        return resolve({isExist: !docs.empty})
                    })
                    .catch(err => console.log(err))
            })

            const checkData = await new Promise((resolve, reject) => {
                db.collection('Data')
                    .where('url', "==", url)
                    .get()
                    .then(docs => {
                        return resolve({isExist: !docs.empty})
                    })
                    .catch(err => console.log(err))
            })

            return resolve(checkPending.isExist || checkData.isExist)
        })


    }

    const submitPendingRequest = async () => {
        setHasError(false)
        setIsExist(false)
        if (validateURL(newPendingRequest.url) && newPendingRequest.country !== '' && newPendingRequest.type !== '' && newPendingRequest.category !== '' && newPendingRequest.subCategory !== '' && newPendingRequest.title !== '') {
           console.log(newPendingRequest)
            const checkExist = await checkExistFn(newPendingRequest.url)
            if (!checkExist) {
                db.collection('Pending')
                    .add(newPendingRequest)
                    .then(res => {
                        setSubmitting(false)
                        setSubmitted(true)
                        //reset
                        setNewPendingRequest({
                            country: '344',
                            type: '',
                            category: "",
                            subCategory: "",
                            description: "",
                            url: '',
                            title: "",
                            rejected:false
                        })
                        setRequireFullReload(true)
                        setTimeout(() => {
                            setRequireFullReload(false)
                            setSubmitted(false)
                        }, 1500)
                    })
            } else {
                setSubmitting(false)
                setRequireFullReload(true)
                setTimeout(() => {
                    setRequireFullReload(false)
                }, 200)
                setIsExist(true)
            }


        } else {
            console.log(newPendingRequest)
            setSubmitting(false)
            setHasError(true)
            setTimeout(() => {
                setHasError(false)
            }, 1500)

        }

    }

    return (
        <div className={classes.SubmitCard}>
            <div className={classes.FormHeading}>
                <Trans>Homepage.heading</Trans>
            </div>

            <div className={classes.InputForm}>
                <div className={classes.InputFormItems}>
                    <div className={classes.InputFormItem}>
                        <label className={classes.Label}>
                            <Trans>Homepage.country</Trans>
                        </label>
                        {
                            requireFullReload ? "" :
                                <Select
                                    isDisabled={submitting}
                                    name="nationality"
                                    defaultValue={{label: "Hong Kong", value: "344"}}
                                    closeMenuOnSelect={true}
                                    options={countryOptArr}
                                    className={newPendingRequest.country === '' ? classes.WarningSelect : ''}
                                    // isDisabled={!this.state.editLanguage}
                                    onChange={(e) => {
                                        setNewPendingRequest({
                                            ...newPendingRequest,
                                            country: e.value.toString()
                                        })
                                    }}
                                />
                        }
                    </div>

                    <div className={classes.InputFormItem}>
                        <label className={classes.Label}>
                            <Trans>Homepage.type</Trans>
                        </label>
                        {
                            requireFullReload ? "" :
                                <Select
                                    name="type"
                                    isDisabled={submitting}
                                    closeMenuOnSelect={true}
                                    options={getAllTypes()}
                                    className={newPendingRequest.type === '' ? classes.WarningSelect : ''}
                                    // isDisabled={!this.state.editLanguage}
                                    onChange={(e) => {
                                        setNewPendingRequest({
                                            ...newPendingRequest,
                                            type: e.value.toString()
                                        })
                                    }}
                                />
                        }
                    </div>

                    <div className={classes.InputFormItem}>
                        <label className={classes.Label}>
                            <Trans>Homepage.category</Trans>
                        </label>
                        {
                            requireFullReload ? "" :
                                <Select
                                    name="type"
                                    isDisabled={submitting}
                                    closeMenuOnSelect={true}
                                    options={getAllCategories()}
                                    className={newPendingRequest.category === '' ? classes.WarningSelect : ''}
                                    // isDisabled={!this.state.editLanguage}
                                    onChange={(e) => {
                                        setRequireReload(true)
                                        setNewPendingRequest({
                                            ...newPendingRequest,
                                            category: e.value.toString()
                                        })
                                        setTimeout(() => {
                                            setRequireReload(false)
                                        }, 200)
                                    }}
                                />
                        }
                    </div>

                    <div className={classes.InputFormItem}>
                        <label className={classes.Label}>
                            <Trans>Homepage.sub-category</Trans> {newPendingRequest.category}
                        </label>
                        {
                            requireReload && newPendingRequest.category !== '' ? "" :
                                <Select
                                    name="type"
                                    isDisabled={submitting}
                                    closeMenuOnSelect={true}
                                    options={getSubCategories(newPendingRequest.category)}
                                    className={newPendingRequest.subCategory === '' ? classes.WarningSelect : ''}
                                    // isDisabled={!this.state.editLanguage}
                                    onChange={(e) => {
                                        setNewPendingRequest({
                                            ...newPendingRequest,
                                            subCategory: e.value.toString()
                                        })
                                    }}
                                />
                        }

                    </div>
                </div>

                <div className={classes.DescriptionContainer}>
                    <div className={classes.InputFormItem}>
                        <label className={classes.Label}>
                            <Trans>Homepage.title</Trans>
                        </label>
                        <input type='text'
                               disabled={submitting}
                               placeholder={'e.g. MeWe 最新資訊'}
                               className={classes.InputField}
                               value={newPendingRequest.title}
                               onChange={(e) => setNewPendingRequest({
                                   ...newPendingRequest,
                                   title: e.target.value
                               })}/>
                    </div>

                    <div className={classes.InputFormItem}>
                        <label className={classes.Label}>
                            <Trans>Homepage.URL</Trans>
                        </label>
                        <input type='text'
                               disabled={submitting}
                               placeholder={'e.g. https://mewe.com/group/55f9dd29e4b050c69e693558'}
                               className={classes.InputField}
                               value={newPendingRequest.url}
                               onChange={(e) => setNewPendingRequest({
                                   ...newPendingRequest,
                                   url: e.target.value.replaceAll(" ","")
                               })}/>
                    </div>

                    <textarea className={classes.Description}
                              placeholder={'介紹 e.g. MEWE新聞和更新'}
                              disabled={submitting}
                              value={newPendingRequest.description}
                              onChange={(e) => {
                                  setNewPendingRequest({
                                      ...newPendingRequest,
                                      description: e.target.value
                                  })
                              }}
                    />
                </div>
            </div>

            <div className={classes.CardBottom}>
                {
                    isExist &&
                    <MDBAlert color='danger'>
                        <Trans>Homepage.exist</Trans>
                    </MDBAlert>
                }
                {
                    hasError &&
                    <MDBAlert color='danger'>
                        <Trans>Homepage.require-fill-in</Trans>
                    </MDBAlert>
                }
                <MDBBtn color={submitting ? 'warning' : submitted ? 'success' : 'primary'} className={classes.SubmitBtn}
                        onClick={() => {
                            setSubmitting(true)
                            submitPendingRequest()
                        }}
                >
                    {submitting ? "loading..." : submitted ? <Trans>Homepage.done</Trans> :
                        <Trans>Homepage.submit</Trans>}
                </MDBBtn>
            </div>
        </div>
    )
}
export default NewPendingRequest